// Angular
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';

// Libraries
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

// Models
import { AppCleanup } from '../../models';

@Component({
	selector: 'filter-menu',
	templateUrl: './filter-menu.component.html',
	styleUrl: './filter-menu.component.scss',
})
export class FilterManuComponent extends AppCleanup implements OnChanges, OnDestroy {
	@Input() externalButton: boolean;
	@Input() action: string;
	@Input() icon: string;
	@Input() items: any[];
	@Input() displayLabel: string;
	@Input() xPosition: 'before' | 'after' = 'before';
	@Input() yPosition: 'above' | 'below' = 'below';

	@Output() onSelect = new EventEmitter();

	@ViewChild('menu', { static: true }) menu!: MatMenu; // Expose the menu reference

	filterTerm: string;
	filteredItems: any[];

	constructor() {
		super();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.items) {
			this.filteredItems = this.items;
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	filterItems() {
		this.filteredItems = this.items.filter((item) => item[this.displayLabel].includes(this.filterTerm));
	}

	clearFilter() {
		this.filterTerm = '';
		this.filterItems();
	}

	itemClicked(item) {
		this.onSelect.emit(item);
		this.filterTerm = '';
		this.filterItems();
	}
}
